export default "__VITE_ASSET__rRoJdJfY__"